import { ReportedHoursVisibleColumnName } from "./types"

export type ReportedHoursColumnSettings = {
  order: ReportedHoursVisibleColumnName[]
  visible: ReportedHoursVisibleColumnName[]
}

export type ReportedHoursGridConfig = {
  id: string
  columnSettings: ReportedHoursColumnSettings
}

export const reportedHoursDefaultColumnOrder: ReportedHoursVisibleColumnName[] = [
  "date",
  "projectOrTask",
  "description",
  "started",
  "finished",
  "hours",
  "status",
  "worker",
  "customer",
  "durationInDecimalHours",
]

export const reportedHoursDefaultVisibleColumns: ReportedHoursVisibleColumnName[] = [...reportedHoursDefaultColumnOrder]

const makeGridConfig = (
  id: string,
  excludedColumns: ReportedHoursVisibleColumnName[] = []
): ReportedHoursGridConfig => ({
  id,
  columnSettings: {
    order: reportedHoursDefaultColumnOrder.filter((column) => !excludedColumns.includes(column)),
    visible: reportedHoursDefaultVisibleColumns.filter((column) => !excludedColumns.includes(column)),
  },
})

export const reportedHoursGridConfigs = {
  organisation: makeGridConfig("organisation"),
  organisationResource: makeGridConfig("organisation-resource", ["customer"]),
  personal: makeGridConfig("personal", ["worker", "customer"]),
}

export const resolveReportedHoursColumnSettings = ({
  columnSettings,
  supportsWorkflowStatus,
  hideTimerColumns,
}: ResolveReportedHoursColumnSettingsOptions): ReportedHoursColumnSettings => {
  const order = supportsWorkflowStatus
    ? columnSettings.order
    : columnSettings.order.filter((column) => column !== "status")
  const availableColumns = new Set(order)
  const visible = columnSettings.visible.filter(
    (column) => availableColumns.has(column) && (!hideTimerColumns || (column !== "started" && column !== "finished"))
  )

  return { order, visible }
}

type ResolveReportedHoursColumnSettingsOptions = {
  columnSettings: ReportedHoursColumnSettings
  supportsWorkflowStatus: boolean
  hideTimerColumns: boolean
}
